import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"left"} }
const _hoisted_2 = { style: {"padding":"20px"} }

import { ref, reactive } from 'vue';
import { layer } from '@layui/layui-vue';
import { allPermissions, addPermissions, delPermissions } from '../../api'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const loading = ref(false);
const selectedKeys = ref([]);
const page = reactive({ current: 1, limit: 10, total: 0 });

const columns = ref([
  { title: "ID", width: "80px", key: "id", fixed: "left", sort: "desc" },
  { title: "父级id", width: "80px", key: "fatherId", sort: "desc" },
  { title: "标题", width: "120px", key: "title" },
  { title: "图标", width: "80px", key: "icon" },
  { title: "路径", width: "80px", key: "path" },
  { title: "路径别名", width: "120px", key: "pathAlias" },
  { title: "验证方式", width: "120px", key: "verify" },
  { title: "排序", width: "120px", key: "px" },
  { title: "备注", width: "120px", key: "remark" },
  { title: "时间", width: "120px", key: "addTime" },
  { title: "操作", width: "150px", customSlot: "operator", key: "operator", fixed: "right", ignoreExport: true }
]);

const change = (page: any) => {
  loadDataSource();
}

const sortChange = (key: any, sort: any) => {
  layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
}

const dataSource = ref([])
const loadDataSource = () => {
  loading.value = true;
  var data = { "page": page.current, "limit": page.limit };
  allPermissions(JSON.stringify(data)).then((res: any) => {
    loading.value = false;
    if (res != "" && res.code == 0) {
      dataSource.value = res.data;
      buildTree(res.data);
      page.total = res.count;
    } else {
      dataSource.value = [];
      page.total = 0;
    }
  })
}

loadDataSource();

//添加
const permissions = reactive({
  id: 0,
  fatherId: "",
  title: "",
  icon: "",
  path: "",
  pathAlias: "",
  verify: "",
  remark: "",
  px:0,
})

const visiblePermissions = ref(false);
const changeVisible11 = () => {
  permissions.id = 0;
  permissions.fatherId = "";
  permissions.title = "";
  permissions.icon = "";
  permissions.path = "";
  permissions.verify = "";
  permissions.pathAlias = "";
  permissions.remark = "";
  permissions.px=0;
  visiblePermissions.value = !visiblePermissions.value;
}

const edit = (row: any) => {
  permissions.id = row.id;
  permissions.fatherId = row.fatherId;
  permissions.title = row.title;
  permissions.icon = row.icon;
  permissions.path = row.path;
  permissions.pathAlias = row.pathAlias;
  permissions.verify = row.verify;
  permissions.remark = row.remark;
  permissions.px= row.px;
  visiblePermissions.value = !visiblePermissions.value;
}

const action11 = ref([
  {
    text: "确认",
    callback: () => {
      addPermissions(JSON.stringify(permissions)).then((res: any) => {
        if (res != "" && res.code == 0) {
          loadDataSource();
          visiblePermissions.value = false;
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })
    }
  },
  {
    text: "取消",
    callback: () => {
      visiblePermissions.value = false;
    }
  }
])

const selectedKey = ref(0);
const dataArr = ref([]);

function buildTree(data: any) {
  const idMap = new Map<number, any>();

  // 初始化节点并添加到映射中
  data.forEach((item: any) => {
    idMap.set(item.id, { ...item, children: [] });
  });

  const result: any = [];

  function addChildNodes(node: any): void {
    data.forEach((item: { fatherId: any; id: number; }) => {
      if (item.fatherId === node.id) {
        const childNode = idMap.get(item.id);
        if (childNode) {
          node.children?.push(childNode);
          addChildNodes(childNode);
        }
      }
    });
  }

  idMap.forEach(node => {
    if (node.fatherId === 0) {
      result.push(node);
      addChildNodes(node);
    }
  });

  dataArr.value = JSON.parse(JSON.stringify(result));
}

const delPermission = (data: any) => {
  data = { "id": data.id };
  delPermissions(JSON.stringify(data)).then((res: any) => {
    if (res != "" && res.code == 0) {
      loadDataSource();
      layer.msg("操作成功", { time: 1000, icon: 1 });

    }
  })
}


return (_ctx: any,_cache: any) => {
  const _component_lay_tree = _resolveComponent("lay-tree")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_tree_select = _resolveComponent("lay-tree-select")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_textarea = _resolveComponent("lay-textarea")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "24" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_tree, {
                  data: dataArr.value,
                  "tail-node-icon": false,
                  onlyIconControl: true,
                  "default-expand-all": true,
                  selectedKey: selectedKey.value,
                  "onUpdate:selectedKey": _cache[0] || (_cache[0] = ($event: any) => ((selectedKey).value = $event))
                }, null, 8, ["data", "selectedKey"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_lay_col, { md: "20" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_table, {
                  page: page,
                  resize: true,
                  height: '100%',
                  columns: columns.value,
                  loading: loading.value,
                  "default-toolbar": false,
                  "data-source": dataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((selectedKeys).value = $event)),
                  onChange: change,
                  onSortChange: sortChange
                }, {
                  toolbar: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_lay_button, {
                        size: "sm",
                        type: "primary",
                        onClick: changeVisible11
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("新增")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  operator: _withCtx(({ row }) => [
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (edit(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "danger",
                      onClick: ($event: any) => (delPermission(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visiblePermissions.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((visiblePermissions).value = $event)),
      shade: false,
      area: ['490px', '715px'],
      btn: action11.value,
      title: "添加/修改"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_lay_form, {
            model: permissions,
            ref: "layFormRef11",
            pane: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "父级id",
                prop: "fatherId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_tree_select, {
                    modelValue: permissions.fatherId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((permissions.fatherId) = $event)),
                    data: dataArr.value,
                    placeholder: "请选择",
                    "allow-clear": true,
                    "default-expand-all": ""
                  }, null, 8, ["modelValue", "data"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "验证方式",
                prop: "verify"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: permissions.verify,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((permissions.verify) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "标题",
                prop: "title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: permissions.title,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((permissions.title) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "图标",
                prop: "icon"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: permissions.icon,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((permissions.icon) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "路径",
                prop: "path"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: permissions.path,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((permissions.path) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "路径别名",
                prop: "pathAlias"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: permissions.pathAlias,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((permissions.pathAlias) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "排序",
                prop: "px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: permissions.px,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((permissions.px) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "备注",
                prop: "remark"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_textarea, {
                    placeholder: "请输入备注",
                    modelValue: permissions.remark,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((permissions.remark) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})